<style scoped>
.faucets .faucet-icons-block .calendar {
    margin: 0 10px 0 0;
    top: -5px;
    position: relative;
}

.faucets .faucet-icons-block .automatic {
    margin: 0 5px 0 0;
    top: -5px;
    position: relative;
}
</style>

<template>
<div class="faucet" :class="blockClass">
    <div v-if="positionStatus == 'open'" class="faucet-position-block faucet-open" 
        :class="{'disable': disableChangePosition}" 
        @click="changePosition(0)"></div>
    <div v-else-if="positionStatus == 'close'" class="faucet-position-block faucet-close" 
        :class="{'disable': disableChangePosition}"
        @click="changePosition(1)"></div>
    <div v-else-if="positionStatus == 'open_process'" class="faucet-position-block faucet-open-process disable"></div>
    <div v-else-if="positionStatus == 'close_process'" class="faucet-position-block faucet-close-process disable"></div>
    <div v-else-if="positionStatus == 'unknown' || positionStatus == 'error'" class="faucet-position-block faucet-atention disable"></div>
    <div class="faucet-name-block">
        <router-link :to="{ name: 'faucet-settings', params: { id_group: id_group, id_faucet: faucet.id_faucet }}">
            {{faucet.name}}
        </router-link>
    </div>
    <div class="faucet-status-block">
        {{positionStatusText}}
    </div>
    <div class="faucet-icons-block">
        <div v-for="icon_element in getIcons" class="icon" :class="icon_element.class" :key="icon_element.type" 
        data-toggle="tooltip" :title="icon_element.text">
        </div>
    </div>
    <div class="faucet-imei-block">
        ID {{deviceSerialNumber}}
    </div>
    <div class="faucet-del-block">
        <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover"></b-btn>
    </div>
    <b-popover :show.sync="del_popover" :target="nameDelButtton" title="Удалить кран из группы" class="faucet-del-popover">
        <button type="button" class="btn btn-outline-danger" @click="deleteFaucet">Да</button>
        <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
    </b-popover>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import {
    store
} from '@/store'

export default {
    name: 'faucet-row',
    created() {
        update_statuses(this)
    },
    data() {
        return {
            block_class: 'faucet-blue-block',
            position_transcription: '',
            icons: [],
            faucet_row_status: true,
            position: false,
            del_popover: false,
            id_group: this.$store.getters.id_group,
            mode: null
        }
    },
    props: {
        faucet: Object
    },
    beforeDestroy() {
        this.faucet_row_status = false
    },
    computed: {
        nameDelButtton: function () {
            return 'delFaucet-' + this.faucet.id_faucet
        },
        getIcons: function () {
            return update_statuses(this)
        },
        blockClass: function () {
            var block_class = ''
            if (this.faucet.position === "error" || this.faucet.position === "unknown") {
                block_class = 'faucet-red-block'
            } else if (this.faucet.position === "open" ||
                this.faucet.position === "close" ||
                this.faucet.position === "open_process" ||
                this.faucet.position === "close_process") {
                block_class = 'faucet-blue-block'
            }

            if (!this.faucet.connection) {
                block_class = 'faucet-gray-block'
            }
            return block_class
        },
        disableChangePosition: function () {
            if (this.faucet.position === "error" || 
                this.faucet.position === "unknown" ||
                this.faucet.position === "open_process" ||
                this.faucet.position === "close_process") {
                return true
            }

            if (this.mode === "auto" || 
                this.mode === "schedule" || !this.mode) {
                return true
            }

            if (!this.faucet.connection) {
                return true
            }
            return false
        },
        positionStatus: function () {
            return this.faucet.position
        },
        positionStatusText: function () {
            var status_text = ''
            if (this.faucet.position === "error") {
                status_text = 'Ошибка'
            } else if (this.faucet.position === "open") {
                status_text = 'Открыт'
            } else if (this.faucet.position === "close") {
                status_text = 'Закрыт'
            } else if (this.faucet.position === "open_process") {
                status_text = 'Открывается'
            } else if (this.faucet.position === "close_process") {
                status_text = 'Закрывается'
            } else if (this.faucet.position === "unknown") {
                status_text = 'Неизвестно'
            }
            return status_text
        },
        deviceSerialNumber: function () {
            var serial_number = this.faucet.device_number.split("-").join("")
            serial_number = serial_number.toUpperCase()
            if (serial_number.length > 0) {
                serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
            }
            return serial_number
        }
    },
    replace: true,
    methods: {
        changePosition: function (position) {
            changePosition(position, this)
        },
        onCloseDelPopover() {
            this.del_popover = false
        },
        deleteFaucet() {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_faucet', this.faucet.id_faucet)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/faucets/delete_faucet_from_group',
                        data: post_data
                    })
                    .then(function (response) {
                        vue_obj.$emit('deleteRow')
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        }
    },
}

function update_statuses(vue_obj) {
    var icons = []
    vue_obj.faucet.statuses.forEach(element => {
        var icon_class = null
        var icon_text = null
        if (element >= 0 && element <= 4) {
            icon_text = "Питание от аккумулятора"
            if (element == 0) {
                icon_class = 'battery-cable-power'
                icon_text = "Питание от сети"
            } else if (element == 1) {
                icon_class = 'battery-1'
            } else if (element == 2) {
                icon_class = 'battery-2'
            } else if (element == 3) {
                icon_class = 'battery-3'
            } else if (element == 4) {
                icon_class = 'battery-4'
            }

            if (icon_class) {
                icons.push({
                    text: icon_text,
                    type: 'battery',
                    class: icon_class
                })
            }
        } else if (element >= 10 && element <= 13) {
            icon_text = "Уровень сигнала Wi-Fi"
            if (element == 10) {
                icon_class = 'no-wifi'
            } else if (element == 11) {
                icon_class = 'wifi-2'
            } else if (element == 12) {
                icon_class = 'wifi-1'
            } else if (element == 13) {
                icon_class = 'wifi'
            }
            if (icon_class) {
                icons.push({
                    text: icon_text,
                    type: 'wifi',
                    class: icon_class
                })
            }
        } else if (element == 'auto') {
            vue_obj.mode = 'auto'
            icons.push({
                text: "Автоматический режим работы крана",
                type: 'mode',
                class: 'automatic'
            })
        } else if (element == 'manual') {
            vue_obj.mode = 'manual'
            icons.push({
                text: "Ручной режим работы крана",
                type: 'mode',
                class: 'push-button'
            })
        } else if (element == 'schedule') {
            vue_obj.mode = 'schedule'
            icons.push({
                text: "Режим работы крана по расписанию",
                type: 'mode',
                class: 'calendar'
            })
        } else if (element == 'lock') {
            vue_obj.mode = 'auto'
            icons.push({
                text: "Кран заблокирован технической службой",
                class: 'lock'
            })
        }
    })
    return icons
}

function changePosition(new_position, vue_obj) {
    if (!vue_obj.disableChangePosition) {
        vue_obj.name_msg = ''
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_faucet', vue_obj.faucet.id_faucet)
        post_data.set('position', new_position)

        axios({
                method: 'POST',
                url: config.API_HOST + '/faucets/change_faucet_position',
                data: post_data
            })
            .then(function (request) {
            })
            .catch(function (error) {
                console.log(error)
            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/faucet_row.vue